<template>
  <div>
    <GenricLoading v-bind:loadingStatus.sync="this.loaderValue" />
    <v-row no-gutters>
      <v-col :cols="8">
        <v-text-field
          v-model="searchString"
          label="Postcode"
          class="textField"
          append-icon="mdi-close"
          @click:append="clear"
        ></v-text-field>
      </v-col>
      <v-col :cols="4">
        <v-btn @click="callValidator" class="btnClass">Search</v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col :cols="8">
        <div v-html="selectedW3W"></div>
      </v-col>
    </v-row>
    <v-row no-gutters id="contentList" style="display:none">
      <v-col :cols="8">
        <v-list dense>
          <v-list-item-group v-model="item" color="primary">
            <v-list-item v-for="(item, i) in items" :key="i">
              <v-list-item-content>
                <v-list-item-title
                  v-text="item.text"
                  @click="displayW3W(item.text, item.w3w, item.city, item.gridEast, item.gridNorth)"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(weatherDataList, j) in weatherData" :key="j" :cols="6">
        <v-card class max-width="344">
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">{{weatherDataList.weatherTimeStamp}}</div>
              <v-list-item-title class="headline mb-1">{{weatherDataList.city}}</v-list-item-title>
              <v-list-item-subtitle>Weather Updates</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar tile size="80" color="grey">
              <img :src="weatherDataList.icon" />
            </v-list-item-avatar>
          </v-list-item>

          <v-card-actions>
            <v-btn text>
              Humidity
              <br />
              {{weatherDataList.humidity}}
            </v-btn>
            <v-btn text>
              Temp
              <br />
              {{weatherDataList.temp}}
            </v-btn>
            <v-btn text>
              Max
              <br />
              {{weatherDataList.temp_max}}
            </v-btn>
            <v-btn text>
              Min
              <br />
              {{weatherDataList.temp_min}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col :cols="6">
        <v-card class max-width="auto" flat>
          <div id="viewDiv" name="viewDiv"></div>
          <div id="loadingDiv" class="loading">Loading Map...</div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import MESSAGE from "@/constants.js";
import PostCode from "@/middleware/PostCode.js";
import GetToken from "@/middleware/GetToken.js";
import GetWeatherUpdates from "@/middleware/GetWeatherUpdates.js";
import utils from "@/utilities/utils.js";
import GenricLoading from "@/components/loading/GenricLoading";
import { loadModules } from "esri-loader";
export default {
  name: "Searchbar",
  components: {
    GenricLoading,
  },
  data: () => ({
    searchString: "",
    selectedW3W: "",
    items: [],
    item: "",
    loaderValue: false,
    weatherData: [],
    apiKey: "CMqDQNmVXqrs5OTPfQFS7yhcAYoPRSwk",
    serviceUrl: "https://api.os.uk/maps/vector/v1/vts",
    view: "",
  }),

  computed: {
    reversedMessage() {
      return this.items.length;
    },
  },

  methods: {
    // call for getting address by Post code
    async callValidator() {
      if (!this.searchString) {
        this.selectedW3W =
          '<span style="color:red">Please enter postcode</span>';
      } else {
        this.postCodeCall();
      }
    },
    async postCodeCall() {
      this.loaderValue = true;
      this.items = [];
      this.weatherData = [];
      this.selectedW3W = "";
      document.getElementById("viewDiv").innerHTML = "";
      document.getElementById("contentList").style.display = "block";
      if (!utils.getCookies()) {
        this.authorizeUser();
      } else {
        const postCodeResponse = await PostCode.getAllAddress(
          this.searchString
        );
        if (postCodeResponse === undefined || postCodeResponse === "") {
          this.selectedW3W = '<span style="color:red">Invalid postcode</span>';
        } else if (postCodeResponse === MESSAGE.INVALID_POST) {
          this.selectedW3W = '<span style="color:red">Invalid postcode</span>';
        } else {
          postCodeResponse.data.map((x) =>
            this.items.push({
              text:
                x.Address.SubBuilding +
                " " +
                x.Address.Building +
                " " +
                x.Address.Thoroughfare +
                " " +
                x.Address.PostTown,
              w3w: x.W3W,
              city: x.Address.PostTown,
              gridEast: x.Additional.grid_east,
              gridNorth: x.Additional.grid_north,
            })        
          );
        }
        this.loaderValue = false;
      }
    },
    async authorizeUser() {
      var tokenRequest = {
        UserName: process.env.VUE_APP_USERNAME,
        Password: process.env.VUE_APP_PASSWORD,
      };

      var resp = await GetToken.getAuthorizationToken(tokenRequest);
      if (resp === undefined) {
        this.isLoading = false;
        this.$router.push({ path: `/404` });
      } else {
        utils.setCookies(resp.data.Token);
        this.getPostDetails();
      }
    },

    async displayW3W(
      selectedaddess,
      w3wSelected,
      cityName,
      gridEast,
      gridNorth
    ) {
      // call for Maps
      this.mapCall(gridEast, gridNorth);

      document.getElementById("contentList").style.display = "none";
      this.selectedW3W = `<b>what3words for postcode ${this.searchString}: </b><i> ${w3wSelected} </i>`;
      this.searchString = selectedaddess;
      this.items = [];

      const weatherResponse = await GetWeatherUpdates.getWeatherInfo(cityName);
      const parseData = weatherResponse;

      parseData.list.forEach((element) => {
        const finalTemp = Math.ceil(element.main.temp - "273.15");

        const MaxTemp = Math.ceil(element.main.temp_max - "273.15");

        const MinTemp = Math.ceil(element.main.temp_min - "273.15");

        const unixTimestamp = element.dt;

        const milliseconds = unixTimestamp * 1000; // 1575909015000

        const dateObject = new Date(milliseconds);

        const humanDateFormat = dateObject.toLocaleString();

        this.weatherData.push({
          description: element.weather[0].description,
          city: element.name,
          icon:
            "http://openweathermap.org/img/wn/" +
            element.weather[0].icon +
            "@2x.png",
          weatherTimeStamp: humanDateFormat,
          humidity: element.main.humidity + "%",
          temp: finalTemp + "°C",
          temp_max: MaxTemp + "°C",
          temp_min: MinTemp + "°C",
        });
      });

      this.weatherData.splice(1, 4);
    },
    mapCall(gridEast, gridNorth) {
      loadModules(
        [
          "esri/Map",
          "esri/views/MapView",
          "esri/layers/VectorTileLayer",
          "esri/geometry/Point",
          "esri/geometry/SpatialReference",
          "esri/config",
          "dojo/dom-class",
          "dojo/domReady!",
        ],
        { css: true }
      ).then(
        ([
          ArcGISMap,
          MapView,
          VectorTileLayer,
          Point,
          SpatialReference,
          esriConfig,
          domClass,
        ]) => {
          esriConfig.request.interceptors.push({
            urls: this.serviceUrl,
            before: function (params) {
              if (!params.requestOptions.query) {
                params.requestOptions.query = {};
              }
              params.requestOptions.query.key =
                "CMqDQNmVXqrs5OTPfQFS7yhcAYoPRSwk"; //this.apiKey;
            },
          });

          var tileLayer = new VectorTileLayer({
            url: this.serviceUrl,
          });

          const map = new ArcGISMap({
            layers: [tileLayer],
          });

          var view = new MapView({
            container: "viewDiv",
            map: map,
            zoom: 10,
            center: new Point({
              x: gridEast,
              y: gridNorth,
              spatialReference: new SpatialReference({ wkid: 27700 }),
            }),
            constraints: {
              rotationEnabled: true,
            },
          });
          view.on("double-click", function (event) {
            event.stopPropagation();
          });
          view.on("mouse-wheel", function (event) {
            event.stopPropagation();
          });
          view.on("key-down", function (event) {
            var prohibitedKeys = ["+", "-", "Shift", "_", "="];
            var keyPressed = event.key;
            if (prohibitedKeys.indexOf(keyPressed) !== -1) {
              event.stopPropagation();
            }
          });
          view.on("drag", function (event) {
            event.stopPropagation();
          });
          view.watch("updating", function (evt) {
            if (evt === true) {
              domClass.add("loadingDiv", "visible");
            } else {
              domClass.remove("loadingDiv", "visible");
            }
          });

         var y = document.getElementsByClassName("esri-ui-inner-container");
          y[0].style.display = "none";
          y[1].style.display = "none";
        }
      );
    },

    clear() {
      this.searchString = "";
      this.selectedW3W = "";
      this.items = [];
      this.weatherData = [];
      document.getElementById("viewDiv").innerHTML = "";
    },
  },
};
</script>
<style scoped>
.v-application--is-ltr .v-card__actions > .v-btn.v-btn + .v-btn {
  margin-left: 1px;
}
.v-list {
  min-height: 100px;
  max-height: 300px;
  overflow-y: auto;
}
.btnClass {
  background-color: #02083c !important;
  color: white !important;
  border-radius: 1px !important;
  margin: 12px !important;
}
.textField {
  width: 430px !important;
}
.esri-view .esri-view-root {
  height: 166px !important;
}
#viewDiv {
  padding: 0;
  margin: 0;
  height: 166px !important;
}
.visible {
  display: block !important;
}
.loading {
  position: absolute;
  top: 100px;
  left: 100px;
  background-color: black;
  color: white;
  display: none;
  padding: 8px;
}
</style>